/**
 * QueryErrorDisplay Component
 *
 * Displays an empty state when a linked table preview query fails.
 */

import { AlertCircle } from 'lucide-react';

interface QueryErrorDisplayProps {
  error: Error;
}

export function QueryErrorDisplay({ error }: QueryErrorDisplayProps) {
  const errorMessage = error.message || 'An unexpected error occurred';

  return (
    <div className="flex h-full flex-col items-center justify-center p-6">
      <div className="flex max-w-md flex-col items-center text-center">
        <div className="bg-destructive/10 mb-4 flex h-12 w-12 items-center justify-center rounded-full">
          <AlertCircle className="text-destructive h-6 w-6" />
        </div>
        <h3 className="text-lg font-semibold">Query Failed</h3>
        <p className="text-muted-foreground mt-2 text-sm">{errorMessage}</p>
      </div>
    </div>
  );
}
